import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _wrapNativeSuper from "@babel/runtime/helpers/wrapNativeSuper";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var HttpError = /*#__PURE__*/function (_Error) {
  _inherits(HttpError, _Error);
  var _super = _createSuper(HttpError);
  function HttpError(_ref) {
    var _this;
    var message = _ref.message,
      statusCode = _ref.statusCode,
      path = _ref.path,
      method = _ref.method,
      xRequestId = _ref.xRequestId,
      headers = _ref.headers;
    _classCallCheck(this, HttpError);
    _this = _super.call(this);
    _this.name = 'HttpError';
    _this.message = message;
    var p = path.split('?')[0];
    _this.path = /^[/-a-z]+$/i.test(p) ? p : '';
    _this.method = method;
    _this.statusCode = statusCode;
    _this.xRequestId = xRequestId;
    _this.headers = Array.from(headers.entries()).map(function (value, key) {
      return "".concat(key, ":").concat(value);
    }).sort().join(',');
    return _this;
  }
  return _createClass(HttpError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
export { HttpError as default };
export var isHttpError = function isHttpError(e) {
  return e instanceof HttpError;
};